/* KingJesus Shop — theme.js v3
   Popup + Color-image-swap + full cart engine
*/
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  function fmt(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Overlay ── */
  const overlay = $('.overlay');
  function showOverlay() { overlay && overlay.classList.add('is-open'); }
  function hideOverlay() { overlay && overlay.classList.remove('is-open'); }

  /* ── Mobile drawer ── */
  const mobileDrawer = $('.mobile-drawer');
  const mobileToggle = $('.mobile-toggle');
  function openMobile() { mobileDrawer && mobileDrawer.classList.add('is-open'); showOverlay(); document.body.style.overflow = 'hidden'; }
  function closeMobile() { mobileDrawer && mobileDrawer.classList.remove('is-open'); if (!$('.cart-drawer.is-open') && !$('.search-overlay.is-open')) hideOverlay(); document.body.style.overflow = ''; }
  if (mobileToggle) mobileToggle.addEventListener('click', openMobile);
  $$('[data-mobile-close]').forEach(b => b.addEventListener('click', closeMobile));

  /* ── Cart drawer ── */
  const cartDrawer = $('#cart-drawer');
  function openCart() { closeMobile(); closeSearch(); cartDrawer && cartDrawer.classList.add('is-open'); cartDrawer && cartDrawer.removeAttribute('aria-hidden'); showOverlay(); document.body.style.overflow = 'hidden'; }
  function closeCart() { cartDrawer && cartDrawer.classList.remove('is-open'); cartDrawer && cartDrawer.setAttribute('aria-hidden', 'true'); if (!$('.mobile-drawer.is-open') && !$('.search-overlay.is-open')) hideOverlay(); document.body.style.overflow = ''; }
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));

  /* ── Search ── */
  const searchOverlay = $('.search-overlay');
  const searchInput = $('[data-search-input]');
  function openSearch() { searchOverlay && searchOverlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; setTimeout(() => searchInput && searchInput.focus(), 50); }
  function closeSearch() { searchOverlay && searchOverlay.classList.remove('is-open'); if (!$('.mobile-drawer.is-open') && !$('.cart-drawer.is-open')) hideOverlay(); document.body.style.overflow = ''; }
  $$('[data-search-open]').forEach(b => b.addEventListener('click', openSearch));
  $$('[data-search-close]').forEach(b => b.addEventListener('click', closeSearch));
  if (overlay) overlay.addEventListener('click', () => { closeMobile(); closeCart(); closeSearch(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeMobile(); closeCart(); closeSearch(); } });

  /* ══ CART ENGINE ══ */
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()); }

  function updateCountBadges(count) {
    $$('[data-cart-count]').forEach(el => { el.textContent = count; count > 0 ? el.removeAttribute('hidden') : el.setAttribute('hidden', ''); });
  }

  function renderCart(cart) {
    if (!cartDrawer) return;
    const title = cartDrawer.querySelector('.cart-drawer__title');
    if (title) title.textContent = `Your Bag (${cart.item_count})`;
    const body = cartDrawer.querySelector('.cart-drawer__body');
    if (body) {
      if (cart.item_count === 0) {
        body.innerHTML = `<div class="cart-drawer__empty"><p>Your bag is empty.</p><a href="/collections/all" class="btn">Shop Now</a></div>`;
      } else {
        body.innerHTML = cart.items.map(item => {
          const imgHtml = item.featured_image ? `<img src="${item.featured_image.url}" alt="${item.title}" loading="lazy" width="80" height="80" style="width:100%;height:100%;object-fit:cover;">` : '';
          const varHtml = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : '';
          return `<div class="cart-item" data-cart-item="${item.key}"><div class="cart-item__img">${imgHtml}</div><div><div class="cart-item__title">${item.product_title}</div>${varHtml}<div class="cart-item__price">${fmt(item.original_price)}</div><div class="cart-item__qty"><button class="cart-item__qty-btn" data-qty-btn="${item.key}" data-delta="-1">&minus;</button><span class="cart-item__qty-num">${item.quantity}</span><button class="cart-item__qty-btn" data-qty-btn="${item.key}" data-delta="1">+</button><button class="cart-item__remove" data-remove-btn="${item.key}">Remove</button></div></div></div>`;
        }).join('');
      }
    }
    const subtotalCents = cart.items.reduce((s, i) => s + i.original_price * i.quantity, 0);
    let foot = cartDrawer.querySelector('.cart-drawer__foot');
    if (cart.item_count > 0) {
      const footHtml = `<div class="cart-drawer__subtotal"><span>Subtotal</span><span>${fmt(subtotalCents)}</span></div><p style="font-size:13px;color:var(--muted);margin-bottom:16px;">Tax and shipping calculated at checkout.</p><form action="/cart" method="post"><button type="submit" name="checkout" class="btn btn--block btn--lg">Checkout</button></form>`;
      if (!foot) { foot = document.createElement('div'); foot.className = 'cart-drawer__foot'; cartDrawer.appendChild(foot); }
      foot.innerHTML = footHtml;
      foot.style.display = '';
    } else {
      if (foot) foot.style.display = 'none';
    }
    bindCartButtons();
  }

  function refreshCart() { return fetchCart().then(cart => { updateCountBadges(cart.item_count); renderCart(cart); return cart; }); }

  function updateItemQty(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(r => r.json()).then(cart => { updateCountBadges(cart.item_count); renderCart(cart); return cart; });
  }

  function bindCartButtons() {
    if (!cartDrawer) return;
    $$('[data-qty-btn]', cartDrawer).forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.qtyBtn;
        const delta = parseInt(btn.dataset.delta, 10);
        const numEl = btn.closest('[data-cart-item]')?.querySelector('.cart-item__qty-num');
        const cur = numEl ? parseInt(numEl.textContent, 10) : 1;
        $$('[data-qty-btn],[data-remove-btn]', cartDrawer).forEach(b => b.disabled = true);
        updateItemQty(key, Math.max(0, cur + delta)).catch(() => $$('[data-qty-btn],[data-remove-btn]', cartDrawer).forEach(b => b.disabled = false));
      });
    });
    $$('[data-remove-btn]', cartDrawer).forEach(btn => {
      btn.addEventListener('click', () => {
        $$('[data-qty-btn],[data-remove-btn]', cartDrawer).forEach(b => b.disabled = true);
        updateItemQty(btn.dataset.removeBtn, 0).catch(() => $$('[data-qty-btn],[data-remove-btn]', cartDrawer).forEach(b => b.disabled = false));
      });
    });
  }

  /* ── Add to cart ── */
  const pdpForm = $('[data-pdp-form]');
  if (pdpForm) {
    pdpForm.addEventListener('submit', e => {
      e.preventDefault();
      const btn = $('[data-atc-btn]', pdpForm);
      const textEl = btn && $('[data-atc-text]', btn);
      if (btn) btn.disabled = true;
      if (textEl) textEl.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(pdpForm), headers: { Accept: 'application/json' } })
        .then(r => r.json())
        .then(data => {
          if (data.status) { if (textEl) textEl.textContent = data.description || 'Error — try again'; if (btn) btn.disabled = false; return; }
          refreshCart().then(openCart);
          if (btn) btn.disabled = false;
          syncAtcBtn();
        })
        .catch(() => { if (textEl) textEl.textContent = 'Error — try again'; if (btn) btn.disabled = false; });
    });
  }

  /* ══ PDP VARIANT SELECTION + COLOR IMAGE SWAP ══ */
  const pdp = $('[data-pdp]');
  let productData = null;
  try { productData = JSON.parse($('[data-product-json]')?.textContent || 'null'); } catch (e) {}

  if (pdp && productData) {
    const optionInputs = $$('[data-option-input]', pdp);
    const variantIdInput = $('[data-variant-id]', pdp);
    const priceEl = $('[data-pdp-price]', pdp);
    const ctaBtn = $('[data-atc-btn]', pdp);
    const ctaText = $('[data-atc-text]', pdp);

    let colorMap = {};
    try {
      const mapEl = document.getElementById('kj-color-map');
      if (mapEl) {
        const raw = mapEl.textContent.trim();
        const inner = raw.replace(/^\{"/, '{').replace(/"\}$/, '}');
        colorMap = JSON.parse(inner);
      }
    } catch (e) { colorMap = {}; }

    let colorOptName = null;
    (productData.options || []).forEach(opt => {
      if (opt.toLowerCase() === 'color' || opt.toLowerCase() === 'colour') colorOptName = opt;
    });

    function selectedOpts() {
      const opts = {};
      optionInputs.forEach(inp => { if (inp.type === 'radio' && !inp.checked) return; opts[inp.dataset.optionName] = inp.value; });
      return opts;
    }

    function findVariant(opts) {
      return productData.variants.find(v => productData.options.every((n, i) => v.options[i] === opts[n]));
    }

    function showSlide(idx) {
      $$('[data-thumb]', pdp).forEach(t => t.classList.toggle('is-active', t.dataset.thumb == idx));
      $$('[data-slide]', pdp).forEach(s => s.classList.toggle('is-active', s.dataset.slide == idx));
    }

    function swapColorImage(colorValue) {
      if (!colorValue) return;
      const key = colorValue.toLowerCase().trim();
      if (typeof colorMap[key] === 'number') showSlide(colorMap[key]);
    }

    function syncAtcBtn() {
      const v = findVariant(selectedOpts());
      if (!v || !ctaBtn) return;
      ctaBtn.disabled = !v.available;
      if (ctaText) ctaText.textContent = v.available ? 'Add to bag - ' + fmt(v.price) : 'Sold out';
    }

    function updateVariant() {
      optionInputs.forEach(inp => {
        const btn = inp.closest('label')?.querySelector('.size-btn');
        if (btn) btn.classList.toggle('is-active', inp.checked);
      });
      optionInputs.forEach(inp => {
        if (!inp.checked) return;
        const labelEl = pdp.querySelector(`[data-opt-val="${productData.options.indexOf(inp.dataset.optionName) + 1}"]`);
        if (labelEl) labelEl.textContent = inp.value;
      });
      const v = findVariant(selectedOpts());
      if (!v) return;
      if (variantIdInput) variantIdInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      syncAtcBtn();
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }

    optionInputs.forEach(inp => {
      inp.addEventListener('change', () => {
        updateVariant();
        if (colorOptName && inp.dataset.optionName === colorOptName) {
          swapColorImage(inp.value);
        }
      });
    });

    updateVariant();
    (() => {
      if (!colorOptName) return;
      optionInputs.forEach(inp => {
        if (inp.dataset.optionName === colorOptName && inp.checked) swapColorImage(inp.value);
      });
    })();

    $$('[data-thumb]', pdp).forEach(thumb => {
      thumb.addEventListener('click', () => { showSlide(thumb.dataset.thumb); });
    });
  }

  refreshCart();
  bindCartButtons();

})();
